import {Breakpoint} from 'antd';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';
import React, {createContext, useContext} from 'react';

export interface ScreenInfo {
    isMobile: boolean;
    isDesktop: boolean;
    screenMap: Record<Breakpoint, boolean>;
}

export const ResponsiveContext = createContext<ScreenInfo | undefined>(undefined);

export function useScreenInfo(): ScreenInfo {
    const contextData = useContext(ResponsiveContext);
    if (contextData === undefined) {
        throw new Error('cannot use outside context');
    }
    return contextData;
}

// ResponsiveProvider
export const ResponsiveProvider: React.FC<{value: ScreenInfo; children?: React.ReactNode}> = (props) => {
    return <ResponsiveContext.Provider value={props.value}>{props.children}</ResponsiveContext.Provider>;
};

export const ResponsiveGate: React.FC<{
    loader?: JSX.Element;
    children?: React.ReactNode;
}> = (props) => {
    const breakpoint = useBreakpoint();
    const canLiftGate = breakpoint.lg !== undefined;
    const isMobile = breakpoint.xs === true && breakpoint.md === false;
    return canLiftGate ? (
        <ResponsiveProvider
            value={{
                screenMap: {
                    xs: breakpoint.xs || false,
                    sm: breakpoint.sm || false,
                    md: breakpoint.md || false,
                    lg: breakpoint.lg || false,
                    xl: breakpoint.xl || false,
                    xxl: breakpoint.xxl || false,
                },
                isMobile,
                isDesktop: !isMobile,
            }}
        >
            {props.children}
        </ResponsiveProvider>
    ) : (
        props.loader || null
    );
};
